import Swiper from "swiper";
import "swiper/css";

export function initNumberedProcess() {
	if (window.acf) {
		window.acf.addAction(
			"render_block_preview/type=numbered-process",
			numberedProcess
		);
	}
}

export function numberedProcess() {
	if (
		!document.querySelector(
			".numbered-process-block .numbered-process-swiper"
		)
	)
		return;

	const swiper = new Swiper(".numbered-process-swiper", {
		loop: true,
		allowTouchMove: false,
	});

	let toggles = document.querySelectorAll(".numbered-process-toggle");
	[...toggles].forEach((v, i, a) => {
		v.addEventListener("click", (e) => {
			let index = v.dataset.index;
			swiper.slideTo(index);
		});
	});
}
